/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown>, used: NonNullable<unknown>, limit: NonNullable<unknown> }} Dashboard_Storage_Almost_FullInputs */



/**
* | output |
* | --- |
* | "Storage is {percent}% full ({used} of {limit}). Free up space or upgrade your plan." |
*
* @param {Dashboard_Storage_Almost_FullInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_storage_almost_full = /** @type {((inputs: Dashboard_Storage_Almost_FullInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Storage_Almost_FullInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Speicher ist zu ${i?.percent}% belegt (${i?.used} von ${i?.limit}). Geben Sie Speicherplatz frei oder upgraden Sie Ihren Plan.`)
	return /** @type {LocalizedString} */ (`Storage is ${i?.percent}% full (${i?.used} of ${i?.limit}). Free up space or upgrade your plan.`)
});